/**
 * Asia/Dubai calendar-date helpers.  Return values are always
 * ISO YYYY-MM-DD strings so string comparison against stored
 * event_date is exact.  Never depends on the visitor's local TZ.
 */

/** Returns 'YYYY-MM-DD' for the current Asia/Dubai calendar date. */
export function getDubaiToday() {
  // en-CA locale emits 'YYYY-MM-DD' natively; forcing the timeZone
  // parameter guarantees the Dubai date regardless of visitor TZ.
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Dubai",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(new Date());
}

/** ms until the next Asia/Dubai midnight (bounded 1 min .. 24 h + margin). */
export function msUntilNextDubaiMidnight() {
  // Get current Dubai HH:MM:SS.
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Dubai",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  }).formatToParts(new Date());
  const map = Object.fromEntries(parts.map((p) => [p.type, p.value]));
  const h = parseInt(map.hour || "0", 10) % 24;
  const m = parseInt(map.minute || "0", 10);
  const s = parseInt(map.second || "0", 10);
  const secondsSinceDxbMidnight = h * 3600 + m * 60 + s;
  const secondsUntilNextDxbMidnight = 24 * 3600 - secondsSinceDxbMidnight;
  // Add a 1-second cushion so setTimeout fires just AFTER midnight,
  // never a millisecond before.
  const ms = (secondsUntilNextDxbMidnight + 1) * 1000;
  return Math.max(60_000, Math.min(ms, 24 * 3600 * 1000 + 60_000));
}

/** Compare an ISO YYYY-MM-DD event date against today (Dubai). */
export function classifyEventDate(eventDate) {
  if (!eventDate) return "upcoming";
  const today = getDubaiToday();
  if (eventDate < today) return "past";
  if (eventDate > today) return "upcoming";
  return "today";
}
